import React from 'react'

export const AutoResizeTextarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    minRows?: number
    maxRows?: number
    value?: string
  }
>(function AutoResizeTextarea({ minRows = 1, maxRows, value, ...rest }, ref) {
  const innerRef = React.useRef<Nullable<HTMLTextAreaElement>>(null)

  const handleRef = (node: HTMLTextAreaElement) => {
    if (typeof ref === 'function') ref(node)
    else if (ref) (ref as React.MutableRefObject<HTMLTextAreaElement | null>).current = node
    innerRef.current = node
  }

  React.useLayoutEffect(() => {
    const textarea = innerRef.current
    if (!textarea) return
    const computed = window.getComputedStyle(textarea)
    // Reset to natural height so that the scrollHeight is correct
    textarea.style.height = 'auto'
    // Set the height to the new calculated value
    textarea.style.height = `${
      textarea.scrollHeight +
      Math.ceil(parseFloat(computed.borderTopWidth)) +
      Math.ceil(parseFloat(computed.borderBottomWidth))
    }px`
  }, [value, minRows])

  return <textarea {...rest} ref={handleRef} rows={minRows} value={value} />
})
